import {ResultsQuestionListTab} from "./results-question-list.component";
import {ReactElement, useEffect, useState} from "react";
import ChatBubbleIcon from "../../../assets/icons-redesign/chat-bubble.svg?react";
import { PulsePollingSurveyDataJSON } from "src/redux/survey/survey.types";

export interface ResultsQuestionListHeaderProps {
  readonly initialTab: ResultsQuestionListTab;
  readonly onTabChange: (tab: ResultsQuestionListTab) => void;
  readonly pulsePollingData?: PulsePollingSurveyDataJSON;
}

const ResultsQuestionListHeader = ({ initialTab, onTabChange, pulsePollingData }: ResultsQuestionListHeaderProps): ReactElement => {
  const [activeTab, setActiveTab] = useState<ResultsQuestionListTab>(initialTab);

  const onTabClick = (tab: ResultsQuestionListTab) => {
    setActiveTab(tab);
    onTabChange(tab);
  };

  useEffect(() => {
    if (pulsePollingData) {
      setActiveTab(ResultsQuestionListTab.PulsePolling);
      onTabChange(ResultsQuestionListTab.PulsePolling);
    }
  }, [pulsePollingData]);

  const renderHeaderTab = (tab: ResultsQuestionListTab, label: string, icon?: ReactElement) => {
    const isActive = activeTab === tab;
    return (
      <div className={`flex py-4 px-1 ${isActive ? 'border-b border-b-blue-500' : ''}`} >
        <div
          className={`cursor-pointer flex items-center gap-1.5 text-sm md:text-base font-medium ${activeTab === tab ? 'text-blue-500' : ''}`}
          onClick={() => onTabClick(tab)}
        >
          {icon}
          {label}
        </div>
      </div>
    );
  };

  const summaryIconStroke = activeTab === ResultsQuestionListTab.Summary ? '#3257FB' : '#191818';
  const pulsePollingIconStroke = activeTab === ResultsQuestionListTab.PulsePolling ? '#3257FB' : '#191818';
  return (
    <div className="flex w-full gap-2 sticky top-0 z-40 bg-gray-200 h-14" >
      {pulsePollingData ? (renderHeaderTab(ResultsQuestionListTab.PulsePolling, 'Pulse Polling', <ChatBubbleIcon stroke={pulsePollingIconStroke} />)) : (
        <>
          {renderHeaderTab(ResultsQuestionListTab.Summary, 'Question Summary', <ChatBubbleIcon stroke={summaryIconStroke} />)}
          {renderHeaderTab(ResultsQuestionListTab.Responses, 'Responses')}
          {/* {renderHeaderTab(ResultsQuestionListTab.Demographics, 'Demographics')} */}
        </>
      )}
    </div>
  );
};

export default ResultsQuestionListHeader;
